import React from 'react';
import { Container, Row, Col, Card, Placeholder } from 'react-bootstrap';

/**
 * Skeleton loader for the Current Conditions card
 */
export const CurrentSkeleton: React.FC = () => (
  <Card>
    <Card.Body>
      <Placeholder as={Card.Title} animation="glow">
        <Placeholder xs={6} />
      </Placeholder>
      <Placeholder as={Card.Subtitle} animation="glow" className="mb-2">
        <Placeholder xs={4} />
      </Placeholder>
      <Container>
        <Row className="pb-2">
          <Col>
            <Placeholder animation="glow">
              <Placeholder xs={8} size="lg" />
              <Placeholder xs={5} />
            </Placeholder>
          </Col>
          <Col>
            <Placeholder animation="glow">
              <Placeholder xs={6} size="lg" />
              <Placeholder xs={4} />
            </Placeholder>
          </Col>
        </Row>
        <Row className="text-center pt-3 border-top border-dark">
          <Col>
            <Placeholder animation="glow">
              <Placeholder xs={8} />
            </Placeholder>
          </Col>
          <Col>
            <Placeholder animation="glow">
              <Placeholder xs={8} />
            </Placeholder>
          </Col>
          <Col>
            <Placeholder animation="glow">
              <Placeholder xs={8} />
            </Placeholder>
          </Col>
        </Row>
      </Container>
    </Card.Body>
  </Card>
);

/**
 * Skeleton loader for the Lunar card
 */
export const LunarSkeleton: React.FC = () => (
  <Card>
    <Card.Body>
      <Placeholder as={Card.Title} animation="glow">
        <Placeholder xs={5} />
      </Placeholder>
      <Container className="text-center">
        <Placeholder animation="glow">
          <Placeholder xs={4} size="lg" className="mb-2" />
        </Placeholder>
        <Row>
          <Col>
            <Placeholder animation="glow">
              <Placeholder xs={10} />
            </Placeholder>
          </Col>
          <Col>
            <Placeholder animation="glow">
              <Placeholder xs={10} />
            </Placeholder>
          </Col>
        </Row>
      </Container>
    </Card.Body>
  </Card>
);

/**
 * Skeleton loader for the Wildfires card
 */
export const WildfiresSkeleton: React.FC = () => (
  <Card>
    <Card.Body>
      <Placeholder as={Card.Title} animation="glow">
        <Placeholder xs={6} />
      </Placeholder>
      <Placeholder as={Card.Subtitle} animation="glow" className="mb-2">
        <Placeholder xs={8} />
      </Placeholder>
      <Container className="p-0">
        <Placeholder animation="glow">
          <Placeholder xs={12} className="mb-2" />
          <Placeholder xs={12} className="mb-2" />
          <Placeholder xs={10} />
        </Placeholder>
      </Container>
    </Card.Body>
  </Card>
);

/**
 * Full page skeleton for lazy-loaded routes
 */
export const PageSkeleton: React.FC = () => (
  <Container fluid="md" className="mt-3" style={{ marginBottom: 100 }}>
    <Row>
      <Col md={7} lg={5} className="mt-1">
        <CurrentSkeleton />
      </Col>
      <Col md={5} lg={7} className="mt-1">
        <Placeholder animation="glow">
          <Placeholder xs={12} style={{ height: '300px', borderRadius: '0.375rem' }} />
        </Placeholder>
      </Col>
    </Row>
    <Row className="mt-3">
      <Col md={12}>
        <WildfiresSkeleton />
      </Col>
    </Row>
  </Container>
);

export default PageSkeleton;
